export function dockFloatingEditorOnly({ toggleEditorDocked } = {}) {
  if (toggleEditorDocked) {
    toggleEditorDocked(true);
  }
}

export function dockFloatingGalleryOnly({ toggleGallery, toggleGalleryDocked } = {}) {
  if (toggleGallery) {
    toggleGallery(false);
  }
  if (toggleGalleryDocked) {
    toggleGalleryDocked(true);
  }
}

export function openEditorModalInDock({
  modalName,
  toggleEditorDocked,
  toggleRightDock,
  setActiveTab,
  openModal
} = {}) {
  if (toggleEditorDocked) {
    toggleEditorDocked(true);
  }
  if (setActiveTab) {
    setActiveTab('editor');
  }
  if (toggleRightDock) {
    toggleRightDock(true);
  }
  if (openModal && modalName) {
    openModal(modalName);
  }
}

export function openGalleryInDock({
  toggleGallery,
  toggleGalleryDocked,
  toggleRightDock,
  setActiveTab
} = {}) {
  if (toggleGallery) {
    toggleGallery(false);
  }
  if (toggleGalleryDocked) {
    toggleGalleryDocked(true);
  }
  if (toggleRightDock) {
    toggleRightDock(true);
  }
  if (setActiveTab) {
    setActiveTab('gallery');
  }
}

export function collapsePanelsIntoRightDock({
  editorDocked,
  galleryDocked,
  toggleEditorDocked,
  toggleGalleryDocked,
  toggleRightDock,
  toggleGallery
} = {}) {
  if (!editorDocked && toggleEditorDocked) {
    toggleEditorDocked(true);
  }
  if (!galleryDocked) {
    if (toggleGallery) {
      toggleGallery(false);
    }
    if (toggleGalleryDocked) {
      toggleGalleryDocked(true);
    }
  }
  if (toggleRightDock) {
    toggleRightDock(false);
  }
}
